export class SessionModel {
  constructor(private token: string | null) {}

  getToken(): string | null {
    return this.token
  }
  updateToken(newToken: string) {
    this.token = newToken
  }

  isActive(): boolean {
    return !!this.token
  }
}
